import { Box } from '@chakra-ui/react';
import { formatUnixTimestamp } from 'Deer/pages/MyData/CheckIns/helper';

export const CurrentCheckInsMetaFilter = ({ dueDate }: { dueDate: number }) => (
  <Box
    display="flex"
    w="max-content"
    mt="12px"
    px="0.625rem"
    py="0.25rem"
    alignItems="center"
    justifyContent="center"
    fontSize="0.875rem"
    fontWeight="600"
    lineHeight="1.25rem"
    bg="neutral.F2F2F2"
    borderRadius="full"
    border="1px solid transparent"
  >
    Check-in date: {formatUnixTimestamp(dueDate)}
  </Box>
);
